import React from 'react'

export default function RoomListPage()
{
    return (
        <div>
            RoomListPage
        </div>
    )
}
